import React from 'react';
import '../static/Assets/css/loader.css';


function LoaderChiCom() {
	return (
		<div id="loader-wrapper">
			<div id="loader"></div>
			<div className="loader-section section-left"></div>
	        <div className="loader-section section-right"></div>
	        <img src={require('../static/Assets/Images/Home/Chi.png')} width={73} alt='logo' style={{position: 'absolute', top: '50%', left: '50%', margin: '-35px 0 0 -35px', zIndex: 9999}} className='animate-flicker'/>
		</div>
	);
}

export default LoaderChiCom;


// WEBPACK FOOTER //
// ./src/config/loader.js